export const NAME = 'navbar';